module.exports = __webpack_public_path__ + "static/media/logo-paanteon-dark-bg.d7494686.svg";